import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppDialog from '@/components/AppDialog.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'
import { editQuote, deleteQuote } from '@/modules/Quote/gql/quote.gql'
import SearchProducer from '@/mixins/search-queries/search-producer'
import { Producer } from '@/modules/Producer/interfaces/producer'
import { SnackType } from '@/interfaces/snack'
import { Quote } from '@/modules/Quote/interfaces/quote'
import { showErrors, showNotification } from '@/utils/snack'
import QuoteForm from '@/modules/Quote/components/QuoteForm.vue'

@Component({
  components: {
    AppDialog,
    AppTextSearch,
    QuoteForm
  }
})
export default class QuoteDialog extends mixins(SearchProducer) {
  targetQuote: Quote | null = null

  quoteDialog = {
    show: false,
    title: 'New Quotes',
    disable: false,
    actionType: 'new',
    step: 0,
    highlightTitle: ''
  }

  deleteQuoteDialog = {
    show: false,
    title: 'Delete Quote',
    disable: false
  }

  changeProducerDialog = {
    show: false,
    title: 'Change Producer',
    disable: false,
    producerId: -1,
    producerName: ''
  }

  assignDialog: {
    [key: string]: any
  } = {
    show: false,
    title: 'Assigned to',
    disable: false
  }

  producerList: Producer[] = []
  get producerOptions () {
    return this.producerList.map(producer => producer.name)
  }

  @Watch('changeProducerDialog.producerName')
  onProducerNameChanged (val: string) {
    if (!val) {
      return
    }
    const producerIndex = this.producerList.findIndex((producer: Producer) => {
      return producer.name === val
    })
    this.changeProducerDialog.producerId = this.producerList[producerIndex].id
  }

  showQuoteDialog (step = 0, targetQuote?: Quote) {
    let actionType = 'new'
    let title = 'New Quote'
    let highlightTitle = ''
    if (targetQuote) {
      this.targetQuote = targetQuote
      actionType = 'edit'
      title = 'Edit Quote : '
      highlightTitle = targetQuote.recordType.name
    }
    this.quoteDialog = {
      actionType,
      show: true,
      title,
      step,
      disable: false,
      highlightTitle
    }
  }

  copyQuote (e: Event, targetQuote: Quote) {
    this.targetQuote = targetQuote
    this.quoteDialog = {
      actionType: 'copy',
      title: 'New Quote',
      show: true,
      step: 0,
      disable: false,
      highlightTitle: targetQuote.recordType.name
    }
  }

  hideQuoteDialog () {
    this.targetQuote = null
    this.quoteDialog = {
      actionType: 'copy',
      show: false,
      title: 'New Quote',
      step: 0,
      disable: false,
      highlightTitle: ''
    }
  }

  async showAssignDialog (e: Event, quote: Quote) {
    e.preventDefault()
    e.stopPropagation()
    this.targetQuote = quote

    this.assignDialog.show = true
  }

  async hideAssignDialog () {
    this.assignDialog = {
      show: false,
      title: 'Assigned to',
      disable: false
    }
  }

  async deleteQuote (e: Event, targetQuote: Quote) {
    e.preventDefault()
    e.stopPropagation()
    this.targetQuote = targetQuote
    this.deleteQuoteDialog.show = true
  }

  async deleteQuotePost () {
    if (!this.targetQuote) {
      return
    }
    const { id } = this.targetQuote
    this.deleteQuoteDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteQuote,
        variables: {
          quoteId: Number(id)
        }
      })

      const res = result.data.deleteQuote
      if (res) {
        showNotification({
          msg: 'Delete quote successfully',
          type: SnackType.Success
        })
        this.targetQuote = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }

  async changeProducerPost () {
    try {
      await this.$apollo.mutate({
        mutation: editQuote,
        variables: {
          quoteInput: {
            name: this.targetQuote ? this.targetQuote.name : null,
            producerId: this.changeProducerDialog.producerId !== -1 ? Number(this.changeProducerDialog.producerId) : null,
            recordTypeId: this.targetQuote ? Number(this.targetQuote.recordType.id) : null
          },
          quoteId: this.targetQuote ? Number(this.targetQuote.id) : null
        }
      })
      this.changeProducerDialog = {
        show: false,
        title: 'Change Producer',
        disable: false,
        producerId: -1,
        producerName: ''
      }
      showNotification({
        msg: 'Update the quote producer successfully',
        type: SnackType.Success
      })
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
